import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    iconContent: {
        justifyContent: "center",
        alignItems: "center",
        height: 50,
        width: 50
    },
    headerTitleContainer: {
        position: "absolute",
        alignItems: "center",
        right: 0,
        left: 0
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    headerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    dateContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    titleContainer: {
        justifyContent: "center"
    },
    contentContainer: {
        alignItems: "flex-start"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    infoCardContainer: {
        flexDirection: "row"
    },
    headerTitle: {
        textAlign: "center"
    },
    container: {
        paddingTop: 0
    },
    dot: {
        height: 2,
        width: 2
    },
    flex1: {
        flex: 1
    }
});
export default stylesheet;
